(() => {
  const PROFILE_TEXT_SELECTOR =
    '.leadership-profiles__profile-text, .leadership-profiles__profile-text-mobile';

  /**
   * Returns the identifier from IDs such as:
   * hover_michael
   * text_michael
   */
  const getProfileIdentifier = (id, prefix) => {
    if (!id || !id.startsWith(prefix)) return '';

    return id.slice(prefix.length);
  };

  /**
   * Finds the matching profile text within the same
   * desktop or mobile leadership container.
   */
  const findMatchingProfileText = (trigger) => {
    const identifier = getProfileIdentifier(trigger.id, 'hover_');

    if (!identifier) return null;

    const leadershipContext = trigger.closest(
      '.leadership-profiles__desktop, .leadership-profiles__mobile'
    );

    if (!leadershipContext) return null;

    const isMobileTrigger = trigger.classList.contains(
      'profile-hover-mobile'
    );

    const selector = isMobileTrigger
      ? '.leadership-profiles__profile-text-mobile'
      : '.leadership-profiles__profile-text';

    return Array.from(
      leadershipContext.querySelectorAll(selector)
    ).find((profileText) => {
      const profileIdentifier = getProfileIdentifier(
        profileText.id,
        'text_'
      );

      return profileIdentifier === identifier;
    });
  };

  /**
   * Hides profile text only within the current desktop/mobile context.
   */
  const hideProfileTexts = (context) => {
    if (!context) return;

    context.querySelectorAll(PROFILE_TEXT_SELECTOR).forEach((profileText) => {
      profileText.style.display = 'none';
    });
  };

  /**
   * Opens and scrolls to the selected profile text.
   */
  const openProfileText = (trigger) => {
    const leadershipContext = trigger.closest(
      '.leadership-profiles__desktop, .leadership-profiles__mobile'
    );

    const matchingProfileText = findMatchingProfileText(trigger);

    if (!leadershipContext || !matchingProfileText) return;

    hideProfileTexts(leadershipContext);

    matchingProfileText.style.display = 'block';

    /*
     * Wait for the browser to recalculate the layout
     * after changing display from none to block.
     */
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        matchingProfileText.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });
  };

  /**
   * Uses event delegation so it continues working
   * after Shopify reloads the section in the theme editor.
   */
  document.addEventListener('click', (event) => {
    const profileTrigger = event.target.closest(
      '.profile-hover, .profile-hover-mobile'
    );

    if (profileTrigger) {
      event.preventDefault();
      openProfileText(profileTrigger);
      return;
    }

    const closeButton = event.target.closest('.close-text');

    if (closeButton) {
      event.preventDefault();

      const profileText = closeButton.closest(PROFILE_TEXT_SELECTOR);

      if (profileText) {
        profileText.style.display = 'none';
      }
    }
  });

  /**
   * Keyboard accessibility for the profile triggers.
   */
  document.addEventListener('keydown', (event) => {
    const profileTrigger = event.target.closest(
      '.profile-hover, .profile-hover-mobile'
    );

    if (
      profileTrigger &&
      (event.key === 'Enter' || event.key === ' ')
    ) {
      event.preventDefault();
      openProfileText(profileTrigger);
    }
  });

  /**
   * Make profile triggers keyboard accessible.
   */
  const initializeProfileTriggers = (container = document) => {
    container
      .querySelectorAll('.profile-hover, .profile-hover-mobile')
      .forEach((trigger) => {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
      });
  };

  initializeProfileTriggers();

  /**
   * Reinitialize accessibility attributes when Shopify
   * reloads the section in the theme editor.
   */
  document.addEventListener('shopify:section:load', (event) => {
    initializeProfileTriggers(event.target);
  });
})();